import { HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MonoTypeOperatorFunction, Observable, retry, throwError, timer } from 'rxjs';

import { GameMode } from '../models/requests/game-mode.enum';
import { isApiErrorStatus } from '../models/responses/api-error-response';
import { GiveUpResponse } from '../models/responses/give-up-response';
import { InteractionResponse } from '../models/responses/interaction-response';
import { GameSessionService } from './game-session';
import { QuemSouEuApiService } from './requests/quem-sou-eu';

@Injectable({ providedIn: 'root' })
export class QuemSouEuGameService {
  private readonly quemSouEuApi = inject(QuemSouEuApiService);
  private readonly gameSession = inject(GameSessionService);

  // O backend decide se o texto é pergunta ou palpite (rota única `interaction`).
  sendInteraction(idSession: string, userText: string): Observable<InteractionResponse> {
    return this.quemSouEuApi
      .sendInteraction(idSession, { userText })
      .pipe(this.retryConflictOnSolo());
  }

  // Encerra a partida como Derrota. Não é uma interação: não entra no histórico.
  giveUp(idSession: string): Observable<GiveUpResponse> {
    return this.quemSouEuApi.giveUp(idSession).pipe(this.retryConflictOnSolo());
  }

  /**
   * 409 = outra requisição gravou a sessão ao mesmo tempo. No Modo Solo não há rota de
   * recarga, então a ação é reenviada uma única vez. No Desafio Diário o erro sobe para
   * a tela, que recarrega a sessão (`GameSessionService.reload`).
   */
  private retryConflictOnSolo<T>(): MonoTypeOperatorFunction<T> {
    return retry({
      count: 1,
      delay: (error: unknown) =>
        this.gameSession.mode() === GameMode.ModoSolo &&
        isApiErrorStatus(error, HttpStatusCode.Conflict)
          ? timer(0)
          : throwError(() => error),
    });
  }
}
